import { Component, Inject, OnInit } from '@angular/core';
import {   FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-exam-subject-gradepoints-pop',
  templateUrl: './exam-subject-gradepoints-pop.component.html',
  styleUrls: ['./exam-subject-gradepoints-pop.component.scss']
})
export class ExamSubjectGradepointsPopComponent implements OnInit {
  Title: string;
  selectedoption = 'group';
  ExamSubForm: FormGroup;
  DefineGrid: FormArray;
  Submitbtn = true;
  Updatebtn = true;

  a1: any = [];
  
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,public umsService: UmsService,
  private dialogRef: MatDialogRef<ExamSubjectGradepointsPopComponent>,
   private fb: FormBuilder) { 
    this.selectedoption = data.id;
  }

  ngOnInit(): void {
    this.SearchEsGrades();
    this.ExamSubForm = this.fb.group({
      DefineGrid: new FormArray([]),
      EsGrdPts: new FormControl('')
    })
    this.getDefineData();
   
  }

  showTitle() {
    if (this.data.value.EsType == 'S' || this.selectedoption == 'S') {
      this.Title = 'Subject';
    } else if (this.data.value.EsType == 'G' || this.selectedoption == 'G') {
      this.Title = 'Group';
    } else if (this.data.value.EsType == 'P' || this.selectedoption == 'P') {
      this.Title = 'Part';
      // this.ExamSubForm.setValue['EsParent'] =
      // this.ExamSubForm.value['EsId'];
    } else if (this.data.value.EsType == 'I' || this.selectedoption == 'I') {
      this.Title = 'In-Part';
    } else if (this.data.value.EsType == 'H' || this.selectedoption == 'H') {
      this.Title = 'Head';
      // this.ExamSubForm.setValue['ESubInPart'] =
      //   this.ExamSubForm.value['EsParent'];
    } else {
    }
  }
  getDefineGridControls() {
    return (this.ExamSubForm.get('DefineGrid') as FormArray).controls;
  }
  addnewDefine() {
    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        EsGrdName: new FormControl(),
        EsGrdPoint: new FormControl()
      })
    );
  }
  getDefineData() {
    let grades = this.data.value.EsGrdPts;
    let Grd = grades.split(',');
    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    if(Grd.length == 0){
      this.addnewDefine();
    }else{
      Grd.forEach((element, i) => {
        let x = element.split(':');
        this.preaddnew(x);
      });
    }
  }

  preaddnew(e) {
    this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
    this.DefineGrid.push(
      this.fb.group({
        EsGrdName: new FormControl(e[0]),
        EsGrdPoint: new FormControl(e[1])
      })
    );

    let a = this.DefineGrid.value;
    let array = [];
    a.forEach((element, i) => {
      this.a1 =
        element.EsGrdName +
        ':' +
        element.EsGrdPoint;
      array.push(this.a1);
    });

  }

  submit(){
    let a = this.DefineGrid.value;
    let submitpayload = {};
    let array = [];
    a.forEach((element, i) => {
      if (
        element.EsGrdName == null &&
        element.EsGrdPoint == null
      ) {
      } else {
        this.a1 =
          element.EsGrdName +
          ':' +
          element.EsGrdPoint;
        array.push(this.a1);
      }
    });
    if (array.length > 0) {
      submitpayload['EsGrdPts'] = array.toString();
    } else {
      submitpayload['EsGrdPts'] = '';
    }
    this.dialogRef.close({data: submitpayload});
  }
  close(){
    let submitpayload = {};
    submitpayload['EsGrdPts'] = '';
    this.dialogRef.close({data: submitpayload}) 
  }

  
  SearchEsGrades(){
    let payload = {};
    payload['EmId'] = this.data.EmId;
    this.umsService.SearchEsGrades(payload).subscribe((res) => {
      if(res.status){
        res.data.forEach(element => {
          this.DefineGrid = this.ExamSubForm.get('DefineGrid') as FormArray;
          this.DefineGrid.push(
            this.fb.group({
              EsGrdName: new FormControl(element.GrMarks + ' / ' + element.GrGrade),
              EsGrdPoint: new FormControl(element.EgpPoints)
            })
          );
        });
        
      }
    })
  }

}
